<template>
  <div class="alipay-container">
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-tickets"></i> 商标管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="alipay-card" shadow="never">
      <div class="search-bar">
        <el-form :model="searchForm" size="small" label-width="70px" label-position="right">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="商标名称">
                <el-input 
                  v-model="searchForm.name" 
                  placeholder="请输入商标名称"
                  prefix-icon="el-icon-search"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="商标注册号">
                <el-input 
                  v-model="searchForm.regSn" 
                  placeholder="请输入注册号"
                  prefix-icon="el-icon-document"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="商标类别">
                <el-select
                  v-model="searchForm.categoryId"
                  placeholder="请选择商标类别"
                  clearable
                >
                  <el-option
                    v-for="item in categoryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="审核状态">
                <el-select
                  v-model="searchForm.status"
                  placeholder="请选择审核状态"
                  clearable
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="待审核" :value="0"></el-option>
                  <el-option label="已通过" :value="1"></el-option>
                  <el-option label="已驳回" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="所属行业">
                <el-cascader
                  v-model="industryList"
                  :props="industryProps"
                  :options="industryOptions"
                  placeholder="请选择所属行业"
                  clearable
                  filterable
                  style="width: 100%;"
                  @change="handleIndustryChange"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="search-actions">
              <el-button type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
              <el-button @click="resetSearch" icon="el-icon-refresh-right">重置</el-button>
              <el-button type="success" @click="addData" icon="el-icon-plus">新增商标</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="stat-cards">
        <div class="stat-card" @click="filterStatus('all')">
          <div class="stat-icon total"><i class="el-icon-tickets"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ totalCount }}</div>
            <div class="stat-label">全部商标</div>
          </div>
        </div>
        <div class="stat-card" @click="filterStatus('pending')">
          <div class="stat-icon pending"><i class="el-icon-time"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ pendingCount }}</div>
            <div class="stat-label">待审核</div>
          </div>
        </div>
        <div class="stat-card" @click="filterStatus('approved')">
          <div class="stat-icon approved"><i class="el-icon-check"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ approvedCount }}</div>
            <div class="stat-label">已通过</div>
          </div>
        </div>
        <div class="stat-card" @click="filterStatus('rejected')">
          <div class="stat-icon rejected"><i class="el-icon-close"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ rejectedCount }}</div>
            <div class="stat-label">已驳回</div>
          </div>
        </div>
      </div>

      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          row-key="id"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          
          <el-table-column label="商标信息" min-width="200">
            <template slot-scope="scope">
              <div class="shop-info">
                <div class="shop-name"><i class="el-icon-tickets"></i><span>{{ scope.row.name || '-' }}</span></div>
                <div class="shop-sn"><span class="label">注册号：</span><span class="value">{{ scope.row.reg_sn || '-' }}</span></div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="商标类别" width="120" align="center">
            <template slot-scope="scope">
              <el-tag size="small" type="primary" effect="plain">
                {{ scope.row.category ? scope.row.category.name : '-' }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column label="联系人" width="130" align="center">
            <template slot-scope="scope">
              <div class="contact-info">
                <div class="contact-name"><i class="el-icon-user"></i><span>{{ scope.row.cont_name || '-' }}</span></div>
                <div class="contact-phone"><i class="el-icon-phone"></i><span>{{ scope.row.telephone || '-' }}</span></div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="所属行业" min-width="180">
            <template slot-scope="scope">
              <div class="address-info">
                <span>{{ scope.row.industry_name || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="审核状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)" size="small" effect="plain">
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand($event, scope.row)">
                <el-button type="primary" size="small" plain>
                  更多操作 <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="view"><i class="el-icon-view"></i> 查看</el-dropdown-item>
                  <el-dropdown-item command="edit"><i class="el-icon-edit"></i> 修改</el-dropdown-item>
                  <el-dropdown-item command="auth" v-if="scope.row.status == 0"><i class="el-icon-check"></i> 审核</el-dropdown-item>
                  <el-dropdown-item command="file"><i class="el-icon-picture"></i> 商标资料</el-dropdown-item>
                  <el-dropdown-item command="del"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrapper" style="margin-top:20px;text-align:right;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10,20,50,100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>

      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-tickets"></i><p>暂无商标数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="450px" :close-on-click-modal="false" class="alipay-dialog" @closed="handleDialogClosed">
      <div class="dialog-content">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="right">
          <el-form-item label="商标名称" prop="name">
            <el-input v-model="form.name" readonly disabled></el-input>
          </el-form-item>
          <el-form-item label="审核状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择审核状态" class="full-width">
              <el-option label="待审核" :value="0"><span style="color: #e6a23c;">● 待审核</span></el-option>
              <el-option label="已通过" :value="1"><span style="color: #00b578;">● 已通过</span></el-option>
              <el-option label="驳回" :value="2"><span style="color: #ff4d4f;">● 驳回</span></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="驳回备注" prop="remark">
            <el-input v-model="form.remark" type="textarea" rows="3" placeholder="请输入驳回备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="fileTitle" :visible.sync="fileDialogVisible" width="600px" class="alipay-dialog">
      <div style="padding:10px 0;">
        <p>商标图片、证书资料展示区域</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fileDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "brandList",
  data() {
    return {
      loading: false,
      totalCount: 0,
      pendingCount: 0,
      approvedCount: 0,
      rejectedCount: 0,
      categoryList: [],
      industryOptions: [],
      industryList: [],
      industryProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      searchForm: {
        name: "",
        regSn: "",
        categoryId: "",
        status: "",
        industryId: ""
      },
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      dialogTitle: '',
      fileDialogVisible: false,
      fileTitle: "商标资料",
      form: { 
        name: '', 
        id: '', 
        status: '',
        remark: ''
      },
      rules: { 
        status: [{ required: true, message: '请选择审核状态', trigger: 'change' }] 
      }
    }
  },
  created() {
    this.getDataList()
    this.getCategoryList()
    this.getIndustryList()
  },
  methods: {
    headerCellStyle() { 
      return { background: '#f5f7fa', color: '#1f2d3d', fontWeight: '500', fontSize: '14px', borderBottom: '1px solid #e4e7ed' } 
    },
    rowStyle() { return { cursor: 'pointer' } },
    getStatusType(status) { 
      return status == 1 ? 'success' : (status == 2 ? 'danger' : 'warning') 
    },
    getStatusText(status) { 
      return status == 1 ? '已通过' : (status == 2 ? '已驳回' : '待审核') 
    },
    handleIndustryChange(value) {
      if (value && value.length > 0) {
        this.searchForm.industryId = value[value.length - 1]
      } else {
        this.searchForm.industryId = ""
      }
    },
    calculateStats() {
      let total = 0, pending = 0, approved = 0, rejected = 0
      this.tableLoadData.forEach(item => {
        total++
        if (item.status == 0) pending++
        else if (item.status == 1) approved++
        else if (item.status == 2) rejected++
      })
      this.totalCount = total
      this.pendingCount = pending
      this.approvedCount = approved
      this.rejectedCount = rejected
    },
    filterStatus(type) {
      if (type === 'pending') this.searchForm.status = 0
      else if (type === 'approved') this.searchForm.status = 1
      else if (type === 'rejected') this.searchForm.status = 2
      else this.searchForm.status = ''
      this.searchSubmit()
    },
    getCategoryList() {
      this.categoryList = [
        {id:1,name:'第1类 化工原料'},
        {id:2,name:'第9类 科学仪器'},
        {id:3,name:'第25类 服装鞋帽'},
        {id:4,name:'第35类 广告销售'}
      ]
    },
    getIndustryList() {
      this.industryOptions = [
        {
          id:1,name:'互联网行业',children:[{id:11,name:'软件开发'},{id:12,name:'电商平台'}]
        },
        {
          id:2,name:'实体商贸',children:[{id:21,name:'服装零售'},{id:22,name:'餐饮服务'}]
        }
      ]
    },
    indexMethod(index) { 
      return (this.pageNum - 1) * this.pageSize + index + 1 
    },
    getDataList() {
      this.loading = true
      setTimeout(() => {
        this.tableLoadData = [
          {id:1,name:'云程商标',reg_sn:'TM20250001',category:{name:'第35类 广告销售'},cont_name:'李四',telephone:'13800138000',industry_name:'互联网/软件开发',status:0},
          {id:2,name:'星辰优品',reg_sn:'TM20250002',category:{name:'第25类 服装鞋帽'},cont_name:'王五',telephone:'13900139000',industry_name:'实体商贸/服装零售',status:1},
          {id:3,name:'蓝海智造',reg_sn:'TM20250003',category:{name:'第9类 科学仪器'},cont_name:'赵六',telephone:'13700137000',industry_name:'互联网/电商平台',status:2}
        ]
        this.total = 3
        this.calculateStats()
        this.loading = false
      }, 600)
    },
    searchSubmit() { 
      this.pageNum = 1 
      this.getDataList() 
    },
    resetSearch() { 
      this.searchForm = { name: "", regSn: "", categoryId: "", status: "", industryId: "" }
      this.industryList = []
      this.searchSubmit() 
    },
    addData() { 
      this.$router.push('/brandForm') 
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getDataList()
    },
    handleCommand(command, row) {
      switch(command) {
        case 'view': this.goView(row); break
        case 'edit': this.goEdit(row); break
        case 'auth': this.goAuth(row); break
        case 'file': this.goFile(row); break
        case 'del': this.delData(row); break
      }
    },
    goView(row) {
      this.$router.push({ path: '/brandInfo', query: { id: row.id } })
    },
    goEdit(row) {
      this.$router.push({ path: '/brandForm', query: { id: row.id } })
    },
    goAuth(row) {
      this.dialogTitle = '商标审核'
      this.form.id = row.id
      this.form.name = row.name
      this.form.status = row.status
      this.form.remark = ''
      this.dialogFormVisible = true
    },
    goFile(row) {
      this.fileTitle = row.name + ' - 商标资料'
      this.fileDialogVisible = true
    },
    delData(row) {
      console.log(row);
      this.$confirm('此操作将永久删除该商标, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('删除成功')
        this.getDataList()
      }).catch(()=>{})
    },
    handleDialogClosed() { 
      this.$refs.form?.resetFields() 
    },
    cancelForm() { 
      this.dialogFormVisible = false 
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid && this.form.id) {
          this.$message.success('审核操作成功')
          this.dialogFormVisible = false
          this.getDataList()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}
.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}
.search-bar {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  .el-form-item { margin-bottom: 16px; width: 100%; }
  .el-form-item__label { font-size: 12px; padding-right: 8px; font-weight: 500; color: #606266; }
  .el-input ::v-deep .el-input__inner,
  .el-select ::v-deep .el-input__inner,
  .el-cascader ::v-deep .el-input__inner {
    border-radius: 20px;
  }
  .search-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: -4px;
    .el-button {
      border-radius: 20px;
      padding: 8px 18px;
    }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
    .el-button--success { background: #00b578; border-color: #00b578; &:hover { background: #1acd8c; border-color: #1acd8c; } }
  }
}
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 160px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease; cursor: pointer;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon { width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff; }
    .stat-info { .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; line-height: 1.2; } .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; } }
    .total { background: linear-gradient(135deg, #1677ff, #4096ff); }
    .pending { background: linear-gradient(135deg, #e6a23c, #ebb563); }
    .approved { background: linear-gradient(135deg, #00b578, #1acd8c); }
    .rejected { background: linear-gradient(135deg, #ff4d4f, #ff7875); }
  }
}
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }
.shop-info { 
  .shop-name { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; i { font-size: 16px; color: #1677ff; } span { font-weight: 500; } } 
  .shop-sn { .label { font-size: 12px; color: #8c8f98; } .value { font-size: 12px; color: #1677ff; font-family: monospace; } } 
}
.contact-info { 
  .contact-name { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; i { color: #e6a23c; font-size: 12px; } span { font-size: 13px; } } 
  .contact-phone { display: flex; align-items: center; gap: 6px; i { color: #00b578; font-size: 12px; } span { font-size: 12px; color: #8c8f98; } } 
}
.address-info { 
  .region { display: flex; flex-wrap: wrap; gap: 4px; margin-bottom: 4px; i { color: #909399; font-size: 12px; margin-right: 4px; } span { font-size: 12px; color: #606266; } } 
  .address { font-size: 12px; color: #8c8f98; word-break: break-all; } 
}
.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }
.alipay-dialog .el-dialog {
  border-radius: 20px; overflow: hidden; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  .el-dialog__header { background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%); padding: 20px 24px; .el-dialog__title { color: #fff; font-size: 18px; font-weight: 500; } }
  .el-dialog__body { padding: 24px; }
  .el-dialog__footer { padding: 16px 24px 24px; border-top: 1px solid #f0f0f0; }
}
.dialog-content .el-form-item { margin-bottom: 22px; }
.full-width { width: 100%; }
.dialog-footer {
  display: flex; justify-content: flex-end; gap: 12px;
  .el-button { border-radius: 24px; padding: 9px 24px; }
  .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
}
.pagination-wrapper {
  ::v-deep .el-pagination {
    .el-pager li { border-radius: 4px; }
    .btn-next,.btn-prev { border-radius: 4px; }
  }
}
@media (max-width: 1200px) {
  .search-bar .search-actions { margin-top: 0; justify-content: flex-start; }
}
</style>